<template>
  <div
    v-if="toasts.length"
    class="fixed z-[100] top-4 right-4 space-y-2 w-80"
    role="status"
    aria-live="polite"
  >
    <div
      v-for="t in toasts"
      :key="t.id"
      :class="[
        'rounded-md shadow-medium border px-4 py-3 text-sm flex items-start gap-2',
        t.type === 'success' ? 'bg-green-50 border-green-200 text-green-800' : '',
        t.type === 'error' ? 'bg-red-50 border-red-200 text-red-800' : '',
        t.type === 'info' ? 'bg-blue-50 border-blue-200 text-blue-800' : '',
        t.type === 'warning' ? 'bg-yellow-50 border-yellow-200 text-yellow-800' : ''
      ]"
    >
      <span class="font-medium">{{ t.title }}</span>
      <span class="ml-auto cursor-pointer opacity-70 hover:opacity-100" @click="dismiss(t.id)">✕</span>
    </div>
  </div>
 </template>

<script>
export default {
  data() {
    return {
      toasts: []
    }
  },
  created() {
    this.$bus.$on('toast:show', this.show);
  },
  beforeDestroy() {
    this.$bus.$off('toast:show', this.show);
  },
  methods: {
    show(payload) {
      const toast = {
        id: Date.now() + Math.random(),
        title: payload.title || 'Saved',
        type: payload.type || 'info',
        timeout: payload.timeout || 2500
      };
      this.toasts.push(toast);
      setTimeout(() => this.dismiss(toast.id), toast.timeout);
    },
    dismiss(id) {
      this.toasts = this.toasts.filter(t => t.id !== id);
    }
  }
}
</script>


